import { render, staticRenderFns } from "./ManageCompany.vue?vue&type=template&id=568bee41&scoped=true"
import script from "./ManageCompany.vue?vue&type=script&lang=js"
export * from "./ManageCompany.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=568bee41&prod&scoped=true&lang=css&external"
import style1 from "./ManageCompany.vue?vue&type=style&index=1&id=568bee41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568bee41",
  null
  
)

export default component.exports